import React from 'react';
import { fromJS } from 'immutable';
import { withStyles } from 'tss-react/mui';
import {
  data as docTypes,
  DSTRAI,
  DKBIS,
  DCNI,
  DRCPRO,
  DDECE,
  DURSSA,
} from '@lba-dev/package.local-globals/docTypes';

import AppleMap from '../../components/Maps/AppleMap';
import Dialogs from '../../components/Dialogs/Dialogs';
import { BankInfo } from '../../components/BankInfo';
import DocumentsList from '../../components/List/Artisan/DocumentsList';
import NoAssurance from '../../components/NoAssurance';
import ReplyMailDialog from '../../components/Dialogs/ReplyMailDialog';
import ExceptionUrssaf from '../../components/ExceptionUrssaf';
import formatAddress from '../../utils/formatAddress';
import ArtisanInfo from '../../components/ArtisanInfo/ArtisanInfo';


const styles = {
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

const DIALOGS_BY_VIEWNAME = {
  Contrat: DSTRAI,
  KBIS: DKBIS,
  CNI: DCNI,
  'Assurance RC Pro': DRCPRO,
  'Assurance Décennale': DDECE,
  URSSAF: DURSSA,
};

const DialogsRecap = ({
  viewDialog,
  paramsDialog,
  artisan,
  handleCloseDialog,
  classes,
  user,
  parentProps: { users },
}) => {
  const type = DIALOGS_BY_VIEWNAME[viewDialog];
  return viewDialog === 'RIB' ? (
    <BankInfo
      defaultText={fromJS(artisan)}
      path="artisans"
      open={paramsDialog.stateDialog}
      onClose={handleCloseDialog}
    />
  ) : (
    <Dialogs
      name={
        <div className={classes.titleContainer}>
          {paramsDialog.dialogTitle}
          {type === DRCPRO && (
            <NoAssurance artisan={artisan} />
          )}
          {type === DURSSA && (
            <>
              <ExceptionUrssaf
                artisan={artisan}
                user={paramsDialog.user || user}
              />
            </>
          )}
        </div>
      }
      open={paramsDialog.stateDialog}
      disagreeText={null}
      agreeText="Fermer"
      maxWidth="md"
      closeAgreeListener={handleCloseDialog}
    >
      {artisan && (
        <ArtisanInfo data={fromJS(artisan)} />
      )}
      {(viewDialog === 'viewMail' && (
        <ReplyMailDialog
          key={8}
          open={viewDialog === 'viewMail'}
          callback={handleCloseDialog}
          defaultText={{
            artisanId: artisan._id
          }}
        />
      )) ||
        (viewDialog === 'Map' && (
          <AppleMap
            height="400px"
            markerList={formatAddress(fromJS([artisan.billingAddress]))}
            marker={{}}
          />
        )) ||
        (type &&
          <DocumentsList
            collection='artisans'
            type={type}
            underscoreId={artisan._id}
            id={artisan.id}
            merge={artisan}
            regex={(docTypes.find(e => e._id === type) || {}).name}
            // Plus de filtrage ici - DocumentsList gère tout
            users={users}
            user={user}
          />
        )}
    </Dialogs>
  );
};

export default withStyles(DialogsRecap, styles);
